// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

(function($) {

    $(document).ready(function() {

        // куки
        function checkMyCookies(){
            let cookieDate = localStorage.getItem('cookieDate');
            let cookieNotification = document.getElementById('cookie_note');
            let cookieBtn = cookieNotification.querySelector('.warning__apply');
            if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
                cookieNotification.classList.add('show');
            }
            cookieBtn.addEventListener('click', function(){
                localStorage.setItem( 'cookieDate', Date.now() );
                cookieNotification.classList.remove('show');
            })
        }
        checkMyCookies();

        $('.node--gallery--full .field--name-field-gallery').photobox('a',{ time:0 });
        $('.view-reviews .item_images').photobox('a',{ time:0 });
        //$('.block--reviews-block .field--name-field-block-image .field__wrapper .field__item').photobox('a',{ time:0 });

        $('.fancy-form').fancybox();

        $('.view-reviews .item_comment_wrapper').readmore({
            speed: 75,
            collapsedHeight: 100,
            moreLink: '<a href="#" class="rm_button_more">Читать полностью</a>',
            lessLink: '<a href="#" class="rm_button_less">Скрыть</a>'
        });

        // плавающая шапка
        $(window).scroll(function() {
            if ($(this).scrollTop() > 0){
                $('#header').addClass("glide");
            }
            else{
                $('#header').removeClass("glide");
            }
        });

        // add now year
        var currentYear = new Date().getFullYear();
        $(".block--copyright-box .now_year").prepend("2014–"+currentYear+" ");

        // карусель projects на главной
/*        $('.block--projects-gallery-block .view-content').slick({
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
        });*/

        // карусель docs на главной
/*        $('.block--project-organization-block .field--name-field-block-image .field__wrapper').slick({
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: 0,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
        });*/

        // карусель reviews на главной
/*        $('.block--reviews-block .field--name-field-block-image .field__wrapper').slick({
            dots: true,
            infinite: true,
            speed: 500,
            autoplay: 0,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
            nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
        });*/


        $('.navmobile_button .btn_open').click(function() {
            $(this).toggleClass('active_btn');
            $('#nav_mobile').toggleClass('show_menu');
            $('body').toggleClass('overflow_bg');
        });

    });
})(jQuery);